<template>
  <div class="main-container">
    <div class="messaging">
      <div class="conversations-list" @keydown.esc="deselectConversation" tabindex="0"
        v-if="!connectionError && !connecting">
        <div class="search">
          <input class="search" type="text" :placeholder="$t('messagingPage.search')" v-model="searchQuery" />
        </div>
        <div class="list">
          <div class="spring-spinner" v-if="loadingConversations">
            <div class="spring-spinner-part top">
              <div class="spring-spinner-rotator"></div>
            </div>
            <div class="spring-spinner-part bottom">
              <div class="spring-spinner-rotator"></div>
            </div>
          </div>
          <div v-for="conversation in sortedConversations" @click="selectConversation(conversation.sid)" :class="`conversation ${selectedConversation.sid == conversation.sid
            ? 'selected-conversation'
            : ''
            }`">
            <h2 class="name noselect">
              {{
                conversation.friendlyName
              }}
            </h2>
            <p class="date noselect">
              {{
                conversation.lastMessage
                  ? dateToTime(conversation.lastMessage.dateCreated)
                  : dateToTime(conversation.dateUpdated)
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="conversation-messages" v-if="selectedConversation.sid">
        <div class="header">
          <p>
            {{
              selectedConversation.friendlyName

            }}
          </p>
        </div>
        <div class="messages-container" ref="messagesContainer" @scroll="paginateMessages()">
          <div class="messages">
            <label class="loadingLabel" v-if="loadingMessages">{{ $t('messagingPage.loading') }}</label>
            <div class="message" v-for="(m, indexMMM) in arrangedConversations" :key="indexMMM"
              :sent="m[0].author === userIdentity ? 'true' : ''">
              <div class="historyStamp"
                v-if="indexMMM === 0 || getFormattedDate(new Date(m[0].dateCreated)) != getFormattedDate(new Date(arrangedConversations[indexMMM - 1][0].dateCreated))">
                <span class="historyStampSpan">{{ getFormattedDate(new Date(m[0].dateCreated)) }}</span>
              </div>
              <div :class="['bubble', { sys_bubble: body.author === 'System' }]" v-for="(body, index) in m"
                :notSeen="body.index > lastReadMessageIndex ? 'true' : ''"
                :CCUser="body.author.includes('MC_taxi_CC') ? 'true' : ''">
                <div class="author" :style="`color:${colorCoding(body.author)};`" v-if="
                  participantsCount > 2 && index == 0
                ">{{isAgent(body.author) ? getFirstName(body.author) : body.author }}
                </div>
                <div class="message-content" v-html="formatBody(body.body)">


                </div>
                <div class="message-info">
                  <span style="float: inline-start">{{
                    $companyTime(body.dateUpdated, "HH[h]mm")
                  }}</span>
                  <!-- <span style="float: inline-end" v-if="!selectedConversation.groupConversation && body.author == userIdentity"> -->
                  <span style="float: inline-end" class="seenSpan">
                    <span>{{
                      body.index <= lastReadMessageIndex ? $t('messagingPage.seen') : $t('messagingPage.sent') }}</span>
                    </span>

                    <span style="float: inline-end" class="seenSpanCC" v-if="body.author.includes('MC_taxi_CC')">
                      <span>{{
                        body.index <= lastReadMessageIndex ? $t('messagingPage.seen') : "" }}</span>
                      </span>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="send-message">
          <textarea style="width: 100%;
            background-color: white;" type="text" rows="3" :disabled="sendingMessage" @keyup.enter="sendMessage"
            v-model="message" :placeholder="$t('messagingPage.sendMessagePlaceholder')" ref="sendTextarea" />
          <!--<button class="send-msg" @click="sendMessage">Send</button>-->

        </div>
      </div>
      <div class="conversation-messages" v-else>
        <div class="no-conversation-selected">
          <label class="noselect" v-if="connecting">
            {{ $t('messagingPage.connectingToTwilio') }}
          </label>
          <label class="noselect" v-else-if="connectionError">
            {{ $t('messagingPage.connectionErrorTwilio') }}
          </label>
          <label class="noselect" v-else>
            {{ $t('messagingPage.selectConversation') }}<br />{{ $t('messagingPage.toStartMessaging') }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { companyFromNow, companyNow, toCompanyMoment } from "@/util/companyTime";

export default {
  name: "Messaging",
  data() {
    return {
      conversations: [],
      participantsCount:0,
      message: "",
      selectedConversation: {},
      selectedConversationMessagesEntity: null,
      loadingMessages: false,
      loadingConversations: false,
      selectedConversationMessages: [],
      client: null,
      storeClientWatcher: null,
      searchQuery: "",
      users: [],
      sendingMessage: false,
      lastReadMessageIndex: -1,
      groupConversation: false,
    };
  },
  computed: {
    connectionError() {
      return this.client &&
        !["connecting", "connected"].includes(this.client.connectionState)
        ? true
        : false;
    },
    connecting() {
      return this.client && this.client.connectionState == "connecting"
        ? true
        : false;
    },
    userIdentity() {
      return this.client.user.identity;
    },
    sortedConversations() {
      if (this.searchQuery == "")
        return this.conversations.sort(function (a, b) {
          let aDate = a.lastMessage ? new Date(a.lastMessage.dateCreated) : 1,
            bDate = b.lastMessage ? new Date(b.lastMessage.dateCreated) : 0;
          return bDate - aDate;
        });
      else return this.search(this.searchQuery);
    },
    arrangedConversations() {
      let conversations = [];
      if (this.selectedConversationMessages.length) {
        let arr = [];
        for (let i = 0; i < this.selectedConversationMessages.length; i++) {
          // if (this.selectedConversationMessages[i + 1]) {
          //   if (
          //     this.selectedConversationMessages[i].author ===
          //     this.selectedConversationMessages[i + 1].author
          //   ) {
          //     arr.push(this.selectedConversationMessages[i]);
          //   } else if (this.selectedConversationMessages[i]) {
          //     arr.push(this.selectedConversationMessages[i]);
          //     conversations.push(arr);
          //     arr = [];
          //   }
          // } else {
          //this.selectedConversationMessages[i].body=  this.selectedConversationMessages[i].body.replace("\n","<br/>")
          arr.push(this.selectedConversationMessages[i]);
          conversations.push(arr);
          arr = [];
          // }
        }
      }
      return conversations;
    },
  },
  methods: {
    formatBody(text) {
      return text.replace(/\n/g, '<br/>');
    },
    getFormattedDate(string) {
      // Final-version doc 2026-10-05: day buckets follow the company clock
      // (UTC+3) and the server-synced now, not the PC's zone.
      const date = toCompanyMoment(string);
      if (!date) {
        return '';
      }
      const today = companyNow();
      if (date.isSame(today, 'day')) {
        return 'today';
      } else if (date.isSame(today.clone().subtract(1, 'day'), 'day')) {
        return 'yesterday';
      } else {
        return `${this.monthName(date.month())} ${this.addLeadingZero(date.date())}`;
      }
    },
    isYesterday(month, day) {
      const currentDate = new Date();
      const targetDate = new Date(currentDate.getFullYear(), month, day);

      // Calculate the date one day ago
      currentDate.setDate(currentDate.getDate() - 1);

      return currentDate.toDateString() === targetDate.toDateString();
    },
    monthName(number) {
      const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct", "Nov", "Dec"
      ];

      return monthNames[number];
    },
    addLeadingZero(value) {
      return value < 10 ? `0${value}` : value;
    },
    getBooleanUnreadMessagesCount() {
      this.$store.dispatch(
        "setUnreadMessageConversationPreference",
        ""
      );
      this.$store.dispatch(
        "setUnreadMessagePreference",
        0
      );
    },
    isAgent(identity) {
      let prefix = "MC_taxi_CC";
      if (typeof identity == "string")
        return identity.includes(prefix);
      return false;
    },
    getFirstName(identity) {     
       let user = this.users.find(u => u.identity == identity) ;
       return user ? user.first_name : identity;
    },
    dateToTime(date) {
      return companyFromNow(date);
    },
    search(q) {
      if (q != "") {
        let arr = [];
        let lowerCaseQuery = q.toLowerCase();
        // console.log("dddd",this.conversations)
        //  console.log("ccc",this.sortedConversations)
        this.conversations.forEach((value) => {
          if (
            value.friendlyName
              .toLowerCase()
              .search(lowerCaseQuery) != -1
          )
            arr.push(value);
        });
        return arr;
      }
    },
    async sendMessage(event) {
      if (event.ctrlKey) {
        // Ctrl+Enter pressed: Insert a new line
        this.message += '\n';
        return;
      }
      if (this.message != "" && !this.sendingMessage) {
        this.sendingMessage = true;
        await this.selectedConversation
          .prepareMessage()
          .setAttributes({
            agentName: `${this.$store.state.user.first_name} ${this.$store.state.user.last_name}`,
            shownName: "Call Center",
          })
          .setBody(this.message)
          .build()
          .send();
        this.sendingMessage = false;
        this.message = "";
        setTimeout(() => {
          if (this.$refs.sendTextarea)
            this.$refs.sendTextarea.focus();
        }, 100);
        // set lastReadMessageIndex for the first time
        let arrayOfMessageIndex = [];
        for (let value of this.selectedConversation.participants.values()) {
          if (!value.identity.includes("MC_taxi_CC")) {
            if (!value.identity.includes("MC_test_CC")) {
              if (value.lastReadMessageIndex) {
                arrayOfMessageIndex.push(value.lastReadMessageIndex);
              }
            }
          }
        }
        if (Math.max(...arrayOfMessageIndex) < 1) {
          this.lastReadMessageIndex = 0;
        } else {
          this.lastReadMessageIndex = Math.max(...arrayOfMessageIndex);
        }

      }

    },
    colorCoding(string) {
      const color = () => Math.floor(Math.random() * (160 - 80 + 1) + 40);
      return `rgb(${color()},${color()},${color()})`;
    },
    selectConversation(sid) {
      if (this.selectedConversation.sid != sid) {
        this.client
          .getConversationBySid(sid)
          .then(async (c) => {
            this.conversations.forEach((e) => {
              e.removeAllListeners("messageAdded", "participantUpdated");
            });
            this.deselectConversation();
            this.selectedConversation = c;
            history.pushState(
              {},
              null,
              this.$route.path + `?conversation=${sid}`
            );

            // set lastReadMessageIndex for the first time
            let arrayOfMessageIndex = [];
            
            // for (let value of this.selectedConversation.participants.values()) {
            //   if (!value.identity.includes("MC_taxi_CC")) {
            //     if (!value.identity.includes("MC_test_CC")) {
            //       if (value.lastReadMessageIndex) {
            //         arrayOfMessageIndex.push(value.lastReadMessageIndex);
            //       }
            //     }
            //   }
            // }
            this.selectedConversation.getParticipants()
              .then(participants => {
                this.participantsCount=participants.length;
                participants.forEach(value => {
                  if (!value.identity.includes("MC_taxi_CC")) {
                    if (!value.identity.includes("MC_test_CC")) {
                      if (value.lastReadMessageIndex) {
                        arrayOfMessageIndex.push(value.lastReadMessageIndex);
                      }
                    }
                  }
                });
              })
              .catch(error => {
                console.error('Error fetching participants:', error);
              });
            console.log("aaaaaaaaaq")
            if (Math.max(...arrayOfMessageIndex) < 1) {
              this.lastReadMessageIndex = 0;
            } else {
              this.lastReadMessageIndex = Math.max(...arrayOfMessageIndex);
            }

            this.selectedConversation.on("messageAdded", (data) => {
              if (data.conversation.sid === this.selectedConversation.sid) {
                this.selectedConversationMessages.push(data);
                this.selectedConversation.setAllMessagesRead();
                setTimeout(this.getBooleanUnreadMessagesCount(), 2000);
                window.requestAnimationFrame(() => {
                  this.$refs.messagesContainer.scrollTop =
                    this.$refs.messagesContainer.scrollHeight;
                });
              }
            });

            // set lastReadMessageIndex for real time communication with captain
            let arrayOfMessageIndex2 = [];
            this.selectedConversation.on("participantUpdated", (event) => {
              if (
                event.participant.conversation.sid ==
                this.selectedConversation.sid
              ) {
                for (let value2 of event.participant.conversation.participants.values()) {
                  if (
                    !value2.identity.includes("MC_taxi_CC") &&
                    !value2.identity.includes("MC_test_CC")
                  ) {
                    if (value2.lastReadMessageIndex) {
                      arrayOfMessageIndex2.push(value2.lastReadMessageIndex);
                    }
                  }
                }
              }
              if (Math.max(...arrayOfMessageIndex2) < 1) {
                this.lastReadMessageIndex = 0;
              } else {
                this.lastReadMessageIndex = Math.max(...arrayOfMessageIndex2);
              }
            });
            this.loadingMessages = true;
            // this.lastReadMessageIndex = -1;
            c.getMessages().then(async (m) => {
              const participants = await c.getParticipants();
              let filteredParticipants = participants.filter(
                (item) => !item.identity.includes("MC_taxi_CC")
              );

              this.selectedConversationMessagesEntity = m;
              this.selectedConversationMessages = [
                ...this.selectedConversationMessages,
                ...m.items,
              ];
              window.requestAnimationFrame(() => {
                this.$refs.messagesContainer.scrollTop =
                  this.$refs.messagesContainer.scrollHeight;
              });
              await c.setAllMessagesRead();
              setTimeout(this.getBooleanUnreadMessagesCount(), 2000);
            });
          })
          .finally(() => {
            this.loadingMessages = false;
            setTimeout(() => {
              if (this.$refs.sendTextarea)
                this.$refs.sendTextarea.focus();
            }, 100);
          });
      }
    },
    paginateMessages() {
      if (!this.loadingMessages) {
        if (
          this.$refs.messagesContainer.scrollTop == 0 &&
          this.selectedConversationMessagesEntity.hasPrevPage
        ) {
          this.loadingMessages = true;
          let loadPrevMessagesScrollPos =
            this.$refs.messagesContainer.scrollHeight;
          this.selectedConversationMessagesEntity.prevPage().then((m) => {
            this.loadingMessages = false;
            this.selectedConversationMessagesEntity = m;
            this.selectedConversationMessages = [
              ...m.items,
              ...this.selectedConversationMessages,
            ];
            window.requestAnimationFrame(() => {
              this.$refs.messagesContainer.scrollTop =
                this.$refs.messagesContainer.scrollHeight -
                loadPrevMessagesScrollPos;
            });
          });
        }
      }
    },
    async retrieveAllConversations() {
      try {
        this.loadingConversations = true;
        let paginator = await this.client.getSubscribedConversations();
        console.log("aaaaaaaaaaaaaaaaaapaginator", paginator)
        this.conversations.push(...paginator.items);
        let cc = this.conversations[0]
        console.log("sssssss", cc.friendlyName)
        console.log("sssssss", cc.lastMessage)
        console.log("sssssss", cc.dateUpdated)
        while (paginator.hasNextPage) {
          paginator = await paginator.nextPage();
          this.conversations.push(...paginator.items);
        }
        //console.log("conversations", this.conversations)
        if (this.$route.query.conversation)
          this.selectConversation(this.$route.query.conversation);
        this.loadingConversations = false;
      } catch (err) {
        console.error('Error fetching conversations:', err);
      } finally {
        this.loadingConversations = false;
      }


    },
    retrieveConversations() {
      this.loadingConversations = true;
      this.client
        .getSubscribedConversations()
        .then((data) => {
          data.nextPage().then((m) => {
            m.items.forEach((val, key) => {
              val.getUnreadMessagesCount().then((cnt) => {
                val.unreadMessagesCount = cnt;
              });
              this.conversations.push(val);
            });

            if (this.$route.query.conversation)
              this.selectConversation(this.$route.query.conversation);

            m.nextPage().then((n) => {
              n.items.forEach((val, key) => {
                val.getUnreadMessagesCount().then((cnt) => {
                  val.unreadMessagesCount = cnt;
                });
                this.conversations.push(val);
              });
              if (this.$route.query.conversation)
                this.selectConversation(this.$route.query.conversation);
              n.nextPage().then((h) => {
                h.items.forEach((val, key) => {
                  val.getUnreadMessagesCount().then((cnt) => {
                    val.unreadMessagesCount = cnt;
                  });
                  this.conversations.push(val);
                });
                if (this.$route.query.conversation)
                  this.selectConversation(this.$route.query.conversation);
                h.nextPage().then((p) => {
                  p.items.forEach((val, key) => {
                    val.getUnreadMessagesCount().then((cnt) => {
                      val.unreadMessagesCount = cnt;
                    });
                    this.conversations.push(val);
                  });
                  if (this.$route.query.conversation)
                    this.selectConversation(this.$route.query.conversation);

                });
              });
            });
          });
          data.items.forEach((val) => {
            val.groupConversation =
              Array.from(val.participants.values()).filter(
                ({ identity }) => !this.isAgent(identity)
              ).length > 1;
            this.conversations.push(val);
          });
          if (this.$route.query.conversation)
            this.selectConversation(this.$route.query.conversation);
        })
        .finally(() => {
          this.loadingConversations = false;
        });

      // this.client
      //   .getSubscribedConversations()
      //   .nextPage()
      //   .then((m) => {});
    },
    deselectConversation() {
      this.selectedConversation = {};
      this.selectedConversationMessages = [];
      this.selectedConversationMessagesEntity = null;
      this.selectedConversationMessagesCount = 0;
      history.pushState({}, null, this.$route.path);
    },
  },
  created() {
    this.client = this.$store.state.conversationClient;
    if (this.$store.state.user.roles[0].name == 'Goverment')
      this.$router.push(`/requests`)
    this.storeClientWatcher = this.$watch(
      "$store.state.conversationClient.conversations",
      (conversations) => {
        this.client = this.$store.state.conversationClient;
        if (this.client.connectionState === "connected")
          this.retrieveAllConversations();
        this.storeClientWatcher();
      },
      {
        immediate: true,
      }
    );
    this.axios.get(`user?allData=1`).then(({ data }) => {
      console.log("users", data)
      this.users = data.data
      console.log("users", this.users)
    });

  },
};
</script>

<style lang="scss" scoped>
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
            supported by Chrome, Edge, Opera and Firefox */
}

.main-container {
  width: 100%;
  height: calc(100vh - 64px);
  padding: 28px;
  display: flex;
  justify-content: center;
  align-items: center;

  .messaging {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    max-width: 1400px;
    display: flex;
    flex-direction: row;
    box-shadow: 0px 0px 6px rgba($color: #000b8a, $alpha: 0.1);
    border-radius: 8px;
    overflow: hidden;

    .conversations-list {
      width: 30%;
      float: inline-start;
      height: 100%;
      border-inline-end: 1px solid #c2c6d9;
      min-width: 300px;
      max-width: 380px;
      flex-shrink: 0;
      flex-grow: 1;
      overflow-y: overlay;
      outline: none;

      &::-webkit-scrollbar {
        width: 0;
      }

      .search {
        width: 100%;
        padding: 16px;
        border-bottom: 1px solid #c2c6d9;
        float: inline-start;
        position: sticky;
        top: 0;
        background: white;

        input {
          padding: 12px 16px;
          border-radius: 6px;
          background: #f7f8fa;
          width: 100%;
          border: 1px solid #c1c5d8;
          color: #222629;
          float: inline-start;
          font-size: 14px;
          height: 40px;

          &::placeholder {
            color: #788e98;
          }

          &:focus {
            outline: none;
          }

          &::after {
            position: absolute;
            inset-inline-end: 12px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      .list {
        width: 100%;
        float: inline-start;
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 12px;

        .selected-conversation {
          box-shadow: inset 0px 0px 0px 1px #e10015 !important;
        }

        .conversation {
          width: 100%;
          box-sizing: border-box;
          padding: 12px 15px;
          border-radius: 8px;
          box-shadow: 0px 0px 6px rgba($color: #000b8a, $alpha: 0.06);
          float: inline-start;
          background-color: white;
          cursor: pointer;
          transition: 0.2s;
          display: flex;
          justify-content: space-between;
          align-items: center;
          overflow: hidden;
          max-width: 100%;
          gap: 12px;

          &:hover {
            box-shadow: 0px 0px 10px rgba($color: #000b8a, $alpha: 0.1);
          }

          .name {
            font-size: 14px;
            font-weight: 500;
            float: inline-start;
            flex-grow: 0;
            flex-shrink: 1;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .last-message {
            font-size: 14px;
            color: #788e98;
            font-weight: 500;
            float: inline-start;
            margin: 0;
            margin-top: 2px;
          }

          .date {
            float: inline-end;
            margin: 0;
            color: #788e98;
            font-size: 14px;
            flex-grow: 0;
            flex-shrink: 0;
          }

          .messages-count {
            float: inline-end;
            width: 18px;
            height: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #e10015;
            border-radius: 100%;
            margin-top: 5px;

            span {
              font-size: 10px;
              color: white;
              font-weight: 600;
              line-height: 0;
            }
          }
        }
      }
    }

    .conversation-messages {
      flex-grow: 1;
      flex-shrink: 1;
      height: 100%;
      float: inline-start;
      display: flex;
      flex-direction: column;

      .header {
        width: 100%;
        padding: 16px 30px;
        float: inline-start;
        font-size: 16px;
        font-weight: 600;
        background: #f0f2f4;
        flex-grow: 0;
        flex-shrink: 0;
        height: 72px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        p {
          margin: 0;
        }
      }

      .messages-container {
        width: 100%;
        float: inline-start;
        flex-grow: 1;
        flex-shrink: 1;
        padding: 12px 26px;
        overflow-y: overlay;
        position: relative;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background-color: #ededed;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #788e98;
        }

        .messages {
          width: 100%;
          max-width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 24px;
          float: inline-start;
          position: relative;

          .loadingLabel {
            margin: auto;
          }

          .message {
            width: 100%;
            max-width: 100%;
            float: inline-start;
            display: flex;
            height: auto;
            align-items: flex-start;
            gap: 5px;
            flex-direction: column;

            &[sent="true"] {
              align-items: flex-end;

              .bubble {
                // background: #fadadd;
                background: #c7e693;
                border: 1px solid #c7e693;

                &[notSeen="true"] {
                  background: #fadadd;
                  border: 1px solid #fadadd;
                }

                float: inline-end;
                border-radius: 12px;
                border-start-end-radius: 0;
                border-end-end-radius: 0;

                &:first-child {
                  border-start-end-radius: 12px;
                }

                &:last-child {
                  border-end-end-radius: 12px;
                }

                .message-info {
                  width: 100%;
                  font-size: 10px;
                  float: inline-start;
                  margin-top: 7px;

                  .seenSpan {
                    display: inline;
                  }

                  .seenSpanCC {
                    display: none;
                  }
                }
              }
            }

            .bubble {
              &[CCUser="true"] {
                background: #c7e693;
                border: 1px solid #c7e693;
              }

              padding: 11px;
              padding-top: 6px;
              padding-bottom: 4px;
              float: inline-start;
              background: #dfe8ec;
              border: 1px solid #d6e0e5;
              border-radius: 12px;
              border-start-start-radius: 0;
              border-end-start-radius: 0;
              max-width: 45%;

              .author {
                font-size: 12px;
                margin-bottom: 4px;
              }

              &:first-child {
                border-start-start-radius: 12px;
              }

              &:last-child {
                border-end-start-radius: 12px;
              }

              .message-content {
                width: 100%;
                font-size: 16px;
                float: inline-start;
                color: #222629;
              }

              .message-info {
                width: 100%;
                font-size: 10px;
                float: inline-start;
                margin-top: 7px;

                .seenSpan {
                  display: none;
                }

                .seenSpanCC {
                  display: inline;
                }
              }
            }

            .sys_bubble {
              background-color: rgb(240 187 192) !important;
            }
          }
        }
      }

      .send-message {
        float: inline-start;
        flex-grow: 0;
        flex-shrink: 0;
        background: #f0f2f4;
        padding: 20px;

        input {
          padding: 12px 16px;
          border-radius: 6px;
          background: #f7f8fa;
          width: 100%;
          border: 1px solid #c1c5d8;
          color: #222629;
          float: inline-start;
          font-size: 14px;

          &::placeholder {
            color: #788e98;
          }

          &:focus {
            outline: none;
          }

          &::after {
            position: absolute;
            inset-inline-end: 12px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      .no-conversation-selected {
        width: 100%;
        height: 100%;
        background: #f6f6f8;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        label {
          font-size: 18pt;
          margin-bottom: 24px;
          text-align: center;
        }
      }
    }
  }

  .historyStamp {
    width: 100%;
    text-align: center;

    .historyStampSpan {
      border: 2px solid white;
      padding: 7px;
      border-radius: 39%;
      background-color: lightgrey;
    }
  }

  .send-msg {
    width: 100%;
    background-color: #d2d2cc;
    padding: 10px;
    border-radius: 5px;
  }
}
</style>
